import React from 'react';
import PropTypes from 'prop-types';

import {connect} from 'react-redux';

import {updateUserPassword} from '../../../ducks/user';
import {asMappedSubmissionError} from '../../../utils/asSubmissionError';

import Modal from '../../../components/modals/Modal';
import ChangePasswordForm from '../../../components/auth/ChangePasswordForm';
import {FormattedMessage} from 'react-intl';

@connect()
export default class ChangePasswordModal extends React.PureComponent {
  static modalName = 'changePassword';

  changePassword = ({currentPassword, newPassword}) =>
    this.props.dispatch(updateUserPassword(currentPassword, newPassword))
      .then(() => this.props.onClose())
      .catch(asMappedSubmissionError({'password': 'currentPassword', 'user.plainPassword': newPassword}));

  render() {
    const {dispatch, ...rest} = this.props;

    return (
      <Modal type="change-password" {...rest}>
        <div className="modal__column">
          <div className="modal__header">
            <FormattedMessage id="section.auth.password.change-title"/>
          </div>
          <ChangePasswordForm onSubmit={this.changePassword}/>
        </div>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./containers/auth/modals/ChangePasswordModal.js